import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localeData);

const getYears = ({ startYear = 1950, yearsCount = 100 }) =>
  new Array(yearsCount).fill(startYear).map((v, i) => ({
    value: v + i,
    name: v + i,
  }));

const months = dayjs.monthsShort().map((v, i) => ({
  value: i,
  name: v,
}));

const weekNames = dayjs.weekdaysMin();

const hours = new Array(24).fill(0).map((v, i) => ({
  name: String(v + i).padStart(2, '0'),
  value: v + i,
}));

const minutes = new Array(60).fill(0).map((v, i) => ({
  name: String(v + i).padStart(2, '0'),
  value: v + i,
}));

const getCalendarPosition = (item, main) => {
  const { height, width } = item.getBoundingClientRect();
  const { top, bottom, right, width: mainWidth } = main.getBoundingClientRect();
  const isTopEnough = (top - 45) > height;
  const isBottomEnough = bottom < document.documentElement.clientHeight - height;

  const vertical = (() => {
    if (!isBottomEnough && !isTopEnough) return 'bottom';
    if (!isBottomEnough) return 'top';
    return 'bottom';
  })();

  const horizontal = (right - mainWidth + width) > document.documentElement.clientWidth ? 'right' : 'left';
  return `${vertical}-${horizontal}`;
}

const style = {
  '--text': '#000',
  '--selected-text': '#FFF',
  '--selected-bg':' #5164F9',
  '--button': '#4D6ECF',
  '--main-bg': '#FFF',
  '--icon':' #8C9EB7',
  '--border': '#CFDAE9',
  '--year': 'rgba(0, 0, 0, 0.1)',
  '--radius': '0.625rem',
}

export {
  getCalendarPosition,
  getYears,
  hours,
  minutes,
  months,
  weekNames,
  style,
}
